import { MantineColor } from "@mantine/core";

import { ReactNode } from "react";
import { BiBullseye } from "react-icons/bi";
import { RiSearch2Line } from "react-icons/ri";

import { IObjective, ObjectiveStatus, ObjectiveType } from "../types/entities";

export const objectiveTypeLabels: Record<IObjective["objective_type"], string> =
  {
    manual_metric: "Metric Objective",
    auto_metric: "Metric Objective",
    learning: "Learning Objective"
  };

export const objectiveTypeIconMap: Record<ObjectiveType, ReactNode> = {
  auto_metric: <BiBullseye color="#6772E6" />,
  manual_metric: <BiBullseye color="#6772E6" />,
  learning: <RiSearch2Line color="#B05BDB" />
};

export const objectiveStatusColor: Record<ObjectiveStatus, MantineColor> = {
  at_risk: "red",
  completed: "violet",
  in_progress: "blue",
  off_track: "orange",
  on_track: "green",
  past_due: "red",
  setup_required: "yellow.7"
};
